import { useQuery } from '@tanstack/react-query';
import { DeviceTypeInfo } from '@repo/shared/dtos/devices/DeviceConnectionDto';

const fetchAvailableDevices = async (): Promise<DeviceTypeInfo[]> => {
  try {
    const response = await fetch('/api/devices/available');
    if (!response.ok) {
      throw new Error('Failed to fetch available devices');
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching available devices:', error);
    throw error;
  }
};

export const useAvailableDevices = () => {
  const {
    data = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['availableDevices'],
    queryFn: fetchAvailableDevices,
    refetchOnMount: true,
    staleTime: 0,
  });

  return {
    availableDevices: data,
    isLoading,
    error,
  };
};
